import React, { useEffect, useState } from "react";
import { Header, Button } from "../components";
import { fileNamePatternIntent, fileNamePatternSentiment, intentDetailTypeData, AgentName, intentTypeData, sentimentTypeData } from "../data/dummy";
import { useStateContext } from "../contexts/ContextProvider";
import AgentComment from "../components/AgentComment";
import AgentCommentMaster from "../components/AgentCommentMaster";
import Wordcloud from "../components/Wordcloud";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';

const VisualizeWordcloud = () => {
  const [userId, setUserId] = useState('');
  const [unixTime, setUnixTime] = useState('');
  const [keywordFreqData, setKeywordFreqData] = useState({});
  //데몽이
  const [isRequestSent_wordcloud, setIsRequestSent_wordcloud] = useState(false);
  const [lambdaResult_wordcloud, setLambdaResult_wordcloud] = React.useState("인사이트 분석시작 버튼을 누르면 분석을 도와드려요!");

  const { currentColor } = useStateContext();
  const navigate = useNavigate();
  const location = useLocation();

  // 키워드별 색상 상태 관리
  const [keywordColors, setKeywordColors] = useState(location.state?.keywordColors || {});

  // 색상 변경 핸들러
  const handleColorChange = (keyword, color) => {
    setKeywordColors((prevColors) => ({
      ...prevColors,
      [keyword]: color, // 특정 키워드에 색상 적용
    }));
  };

  // 상세 페이지로 이동
  const goToDetailPage = () => {
    navigate("/vis/wordcloud-detail", { state: { keywordColors } });
  };

  const handleLambdaRequest = async () => {
    if (isRequestSent_wordcloud) return;
    // 요청 상태 업데이트
    setIsRequestSent_wordcloud(true);

    const vis_cloud_word = "이체, 디자인, 보안, 한도, 접속, 에러, 포인트, 인증, 출금, 계좌, 알림";
    try {
      let requestData;

      requestData = {
        name: "llm_vis_1",
        vis_cloud_word: vis_cloud_word,
      };
      const response = await axios.post(
        "https://farqijyj9a.execute-api.ap-northeast-2.amazonaws.com/241113/agent",
        requestData
      );

      // 요청 데이터 출력
      console.log("요청 데이터:", requestData);

      // Lambda 응답 디코딩 및 처리
      const responseBody = JSON.parse(response.data.body); // `body`를 JSON으로 파싱
      console.log("Lambda 응답:", responseBody);

      // Lambda 결과값 반영
      setLambdaResult_wordcloud(responseBody.answer || "결과를 불러왔습니다.");

    } catch (error) {
      console.error("Lambda 호출 중 오류 발생:", error);
      setLambdaResult_wordcloud("오류가 발생했습니다. 다시 시도해주세요.");
    } finally {
      // 요청 상태 초기화 (성공/실패 관계 없이 재시도 불가)
      setIsRequestSent_wordcloud(true);
    }
  };

  useEffect(() => {
    const storedUserID = localStorage.getItem('userId');
    setUserId(storedUserID || '');
    console.log(`storedUserID: ${storedUserID}`);

    const storedUnixTime = localStorage.getItem('unixTime');
    setUnixTime(storedUnixTime || '');
    console.log(`storedUnixTime: ${storedUnixTime}`);

    const storedKeywordFreq = localStorage.getItem('keywordFreqData');
    setKeywordFreqData(storedKeywordFreq || {});
    console.log(`storedKeywordFreq: ${storedKeywordFreq}`);
  }, []);

  return (
    <div className="m-2 md:m-10 mt-0 p-2 md:p-10 bg-white rounded-3xl">

      <Header category="데이터 시각화" title="워드클라우드(WordCloud)" />
      <br />
      <button
        onClick={async () => {
          console.log("Button clicked!"); // 클릭 시 콘솔 출력

          const swalInstance = Swal.fire({
            title: '인사이트 분석 시작',
            html: '새로고침하지 마시고 잠시만 기다려주세요.<br>최대 1분까지 소요될 수 있어요.',
            icon: 'info',
            timer: 60000, // 1분 타이머 설정
            allowOutsideClick: false, // 팝업 밖 클릭 비활성화
            allowEscapeKey: false,    // ESC 키 비활성화
            allowEnterKey: false,     // 엔터 키 비활성화
            timerProgressBar: true,   // 타이머 진행 바 표시
            didOpen: () => {
              Swal.showLoading();     // 팝업 로딩 애니메이션 표시
            },
          });

          try {
            const response = await handleLambdaRequest(); // Lambda 요청 실행
            console.log('Response received:', response);

            // 요청 성공 시 팝업 닫기
            Swal.close();
            Swal.fire({
              title: '분석 완료',
              html: '데몽이의 분석 가이드를 확인해 보세요 :)',
              icon: 'success',
              confirmButtonText: '확인',
              confirmButtonColor: currentColor,
            });
          } catch (error) {
            console.error('Error during request:', error);

            // 요청 실패 시 에러 팝업 표시
            Swal.close();
            Swal.fire({
              title: '분석 실패',
              html: '요청을 처리하는 중 오류가 발생했습니다.<br>다시 시도해주세요.',
              icon: 'error',
              confirmButtonText: '확인',
              confirmButtonColor: currentColor,
            });
          }
        }}
        style={{
          backgroundColor: currentColor, // 배경색
          color: 'white',                // 텍스트 색상
          borderRadius: '10px',          // 모서리 둥글게
          padding: '12px 24px',          // 버튼 패딩
          fontSize: '16px',              // 폰트 크기
          cursor: 'pointer',             // 마우스 커서
          border: 'none',                // 테두리 제거
          transition: 'background-color 0.3s', // 배경색 변화에 트랜지션 추가
        }}
        className="hover:bg-gray-700 hover:drop-shadow-xl" // 호버 시 효과 추가
      >
        인사이트 분석시작
      </button>
      <AgentCommentMaster
        title={"데몽이의 조언"}
        comment={lambdaResult_wordcloud}
      />

      {/* 워드클라우드 */}
      <div className="bg-white p-8 rounded-3xl shadow-lg mb-12">
        {intentTypeData.map((intentName, index) => (
          <div>
            <div className="flex gap-1 items-center">
              <p className="text-xl font-semibold">{intentName} 리뷰</p><br />
              {/* <Button
                color="white"
                bgColor={currentColor}
                text="상세조회하기"
                borderRadius="10px"
                onClick={() => navigate("/vis/wordcloud-detail",
                               { state: { intentName } })}
              /> */}
            </div>
            <br />
            <div className="flex gap-5">
              {/* 각 워드클라우드 컨테이너에 flex: 1 적용 */}
              {sentimentTypeData.map((sentiment, index) => (
              <div className="flex-1">
                  <p className="text-xl font-semibold">[{sentiment} 리뷰]</p>
                  <br/>
                  <Wordcloud sentiment={sentiment} intentName={intentName}
                             pageType={"전체"} keywordColors={keywordColors} />
                </div>
              ))}
            </div>
            <hr className="my-8 border-gray-300" />
          </div>
        ))
        }


      </div>
      <div className="flex justify-end">
        <Button
          color="white"
          bgColor={currentColor}
          text="▶키워드 빈도 확인하기"
          borderRadius="10px"
          onClick={() => navigate('/vis/wordfreq')}
        />
      </div>
    </div>
  );
};

export default VisualizeWordcloud;
